import React from "react";
import { Calendar, Lock } from "lucide-react";

export default function TimelineView({ timeline }) {
  if (!timeline || !timeline.points) return null;
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div>
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center gap-2">
          <Lock className="w-3.5 h-3.5 text-[#d4af37]"/>
          <p className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#d4af37]">Universal Timeline (SSOT)</p>
        </div>
        <span className="text-[10px] font-mono uppercase tracking-widest text-gray-500">D0 · {timeline.d0} · X = {timeline.X_working_days} working days</span>
      </div>
      <div className="iz-card overflow-hidden">
        {timeline.points.map((p, i) => {
          const past = p.date <= today;
          const isToday = p.date === today;
          return (
            <div key={p.key} className={`flex items-center gap-4 px-5 py-3 border-b border-[#1a1a1a] last:border-b-0 ${isToday ? "bg-[#d4af37]/5" : ""}`} data-testid={`timeline-${p.key}`}>
              <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-xs font-mono ${past ? "bg-[#d4af37] text-black" : "bg-[#1a1a1a] text-gray-500"}`}>
                {i + 1}
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-sm ${past ? "text-white" : "text-gray-400"}`}>{p.label}</p>
                <p className="text-[10px] font-mono text-gray-500">+{p.offset_working_days} working days</p>
              </div>
              <div className="text-right">
                <p className={`text-sm font-mono ${past ? "text-[#d4af37]" : "text-gray-400"}`}>{p.date}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
